let priceElement = document.getElementById("price");
if (priceElement) {
  priceElement.addEventListener("click", function () {
    let variantId = priceElement.dataset.variantId;
    Shopify.getProductVariant(variantId, function (variant) {
      let newPrice = variant.price | money;
      priceElement.textContent = newPrice;
      Shopify.getCart(function (cart) {
        let lineItem = cart.items.find(function (item) {
          return item.variant_id == variantId;
        });
        if (lineItem) {
          Shopify.changeItem(
            lineItem.key,
            { price: newPrice }
          );
        }
      });
    });
  });
}
